<template>
    <!-- 加入會員 dialog -->
    <el-dialog
            class="dialog"
            :visible.sync="showModel"
            :modal="isModal"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :modalAppendToBody="false"
            custom-class="commDialog">

        <!-- 右上角關閉按鈕，當 isCancel == true 並且 negativeLabel爲空白才會出現 -->
        <el-row type="flex" justify="space-between" v-if="isShowClose">
            <slot name="left">
                <el-col :span="7"/>
            </slot>
            <slot name="center">
                <el-col :span="10"/>
            </slot>
            <slot name="right">
                <el-col :span="7">
                    <!--todo 關閉-->
                    <el-button class="close" @click="cancel"/>
                </el-col>
            </slot>
        </el-row>
        <el-row type="flex" justify="space-between" v-else />

        <div id="commDialogContainer">
            <div v-show="!showPolicy" class="container" >
                <img v-show="isIcon" :src="icon" class="icon">
                <span slot="title" class="outer-content">{{outerContent}}</span>
                <span v-show="mainContent!==''" class="main-content">{{mainContent}}</span>
                <div class="ml-2 mt-2 privacy">
                    <el-checkbox v-model="isAgreePolicy">我已閱讀並同意 <span @click="onClickPolicy">隱私權條款</span></el-checkbox>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="cancel" round v-show="isCancel && negativeLabel!=='' " type="info">{{negativeLabel}}</el-button>
                    <el-button @click="confirm" round type="primary">{{positiveLabel}}</el-button>
                </div>
            </div>
            <div v-show="showPolicy" class="container" >
                <span v-show="secondContent!==''" class="main-content" v-html="secondContent"/>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="onClickConfirmPolicy" round type="primary">確定</el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    //載入隱私權聲明，使用 raw-loader套件
    import PrivateContent from 'raw-loader!@/assets/private.html';

    export default {
        name: "JoinMemberDialog",
        components: {

        },
        props: {
            icon: {default: require('@/assets/images/dialog_question.svg')},
            outerContent: {default: "提醒"},
            mainContent: {default: ''},
            positiveLabel: {default: "確定"},
            negativeLabel: {default: "取消"},
            value: {required: false, type: Boolean, default: false},        //是否顯示 dialog (dialog開關)?
            eventType: {required: false, type: Number, default: 0},            //事件種類辨認用，會在 result 中回傳，可以在顯示 dialog前設定好，在 result中以此來辨認目前是哪個事件的 result
            isCancel: {default: true},
            isModal: {default: true},
            isShowClose: {default: false},
            isIcon: {default: true},

        },
        data() {
            return {
                showModel: this.value,
                isAgreePolicy: false,
                showPolicy: false,
                secondContent: '',
                
            }
        },
        created() {

        },
        mounted() {
            //如果右上 close 顯示了，isCancel 就不顯示
            if (this.isShowClose) {
                this.isCancel = false;
            }

            // this.secondContent = '\u003cp\u003e前言:\u003c/p\u003e\u003cp\u003e為提升會員服務品質及迅速加快您註冊的時間，台灣享樂遊使用《LifeLink品牌服務系統》，只要您曾在《LifeLink品牌服務系統》填過一次個人基本資料，在此台灣享樂遊的會員隱私條款中，您只要勾選”同意”，即可迅速完成註冊，成為台灣享樂遊會員。\u003c/p\u003e\u003cp\u003e\u0026nbsp;\u003c/p\u003e\u003cp\u003e惟為維護個人隱私權與支持個人資料保護，台灣享樂遊依下列隱私權聲明向您說明蒐集個人資料之項目及利用範圍，並告知您所得行使權利事項。\u003c/p\u003e\u003cp\u003e\u0026nbsp;\u003c/p\u003e\u003cp\u003e第一條：個人資料蒐集之項目\\n\u003c/p\u003e\u003cp\u003e為提供完整的服務及售後服務，台灣享樂遊將透過《LifeLink品牌服務系統》蒐集您的姓名、聯絡方式（包括但不限於手機門號、姓名、性別、生日、E-MAIL及地址等、為完成收款或付款所需之資料、IP位址及其他得以直接或間接識別使用者身分之個人資料）。此外，為提升服務品質，台灣享樂遊會依照其提供服務之性質，記錄使用者的IP位址以及記錄您在台灣享樂遊相關網站或app內的瀏覽活動(例如，使用者所使用的軟硬體、所點選的網頁、下載的app)，但是這些紀錄資料僅供作流量分析和網路行為調查用，以利於提升並改善台灣享樂遊相關服務，然台灣享樂遊不會私下與特定個人聯繫。\u003c/p\u003e\u003cp\u003e\u0026nbsp;\u003c/p\u003e\u003cp\u003e第二條：個人資料蒐集之利用範圍\\n\u003c/p\u003e\u003cp\u003e一、台灣享樂遊透過《LifeLink品牌服務系統》蒐集足以識別您身分的個人基本資料、消費與交易資料或日後經您同意而提供之其他個人更多資料，都僅供台灣享樂遊於其內部、履行合約義務範圍內或依照相關法令規定及有權主管機關（包括但不限於法院或台灣票據交換所）之命令作使用，否則台灣享樂遊不會將足以識別您身分的個人資料提供給第三人（包括境內及境外）或移作蒐集目的以外之使用。\\n\u003c/p\u003e\u003cp\u003e二、台灣享樂遊會將透過《LifeLink品牌服務系統》蒐集之個基本人資料提供予合作廠商（包括但不限提供本服務之LifeLink品牌服務系統、宅配貨運業者或其他）以協助交易完成或終止。若選擇以信用卡方式支付，僅限信用卡持卡人本人使用，且得就此交易資料向發卡銀行、收單行及持卡人照會並確認是否屬實，於核對無誤後付款程序才算完成。\u003c/p\u003e\u003cp\u003e\u0026nbsp;\u003c/p\u003e\u003cp\u003e\u0026nbsp;第三條：資料當事人之權利 \u003c/p\u003e\u003cp\u003e一、您可以請求查詢及閱覽您於《LifeLink品牌服務系統》填妥之個人基本資料或要求給予副本。\u003c/p\u003e\u003cp\u003e二、若您的個人基本資料已變更或不正確，請告知台灣享樂遊修改以確保您的權益。當蒐集個人基本資料之目的消失，您可要求台灣享樂遊刪除、停止處理或利用您的個人基本資料。但因台灣享樂遊執行職務或業務所必須者，不在此限。\\n\u003c/p\u003e\u003cp\u003e三、為便利您使用台灣享樂遊網站，台灣享樂遊網站會讀取儲存在使用者電腦中的台灣享樂遊資料。使用者可以經由瀏覽器的設定，取消或限制此項功能，但可能因此無法使用部分網站功能。若您想知道如何取消或限制此項功能，請與台灣享樂遊客服中心聯絡。\u003c/p\u003e\u003cp\u003e\u0026nbsp;\u003c/p\u003e\u003cp\u003e第四條：資料處理與傳輸之同意\\n\u003c/p\u003e\u003cp\u003e一、當您使用我們的任一服務或與之互動時，您同意我們根據本隱私權聲明所述內容，對您的資訊進行資料處理、分享、傳輸和使用。無論您居住的國家/地區為何，您都授權我們根據本隱私權聲明在您所居住國家/地區以外之處傳輸、處理、儲存和使用您的資訊以及向您提供服務。部分國家/地區對資料保護的嚴密程度可能與您所居住之國家/地區不同。 \u003c/p\u003e\u003cp\u003e二、《LifeLink品牌服務系統》可能會處理與位於歐盟/歐洲經濟區境內之個人相關的資訊，並可能透過多種法規遵循機制從歐盟/歐洲經濟區境內傳輸該等資訊，此等法規遵循機制包括依歐盟/歐洲經濟區標準契約條款制定的資料處理協議。使用我們的服務即表示您同意我們將與您相關的資訊傳輸到這些國家/地區。如需更多資訊，請參閱我們的資料傳輸頁面。\u003c/p\u003e\u003cp\u003e\u0026nbsp;\u003c/p\u003e\u003cp\u003e第五條：修訂之權利 \u003c/p\u003e\u003cp\u003e台灣享樂遊有權隨時修訂本隱私權聲明及相關告知事項，並得於修訂後公佈在台灣享樂遊網站，恕不另行通知。您可以在台灣享樂遊網站上詳閱修訂後的隱私權聲明及相關告知事項。\u003c/p\u003e\u003cp\u003e如果您對於台灣享樂遊使用《LifeLink品牌服務系統》隱私權聲明及上述事項有任何疑問，請和台灣享樂遊客服中心聯絡，我們將儘快回覆並為您說明，謝謝。\u003c/p\u003e\u003cp\u003e\u003cbr\u003e\u003c/p\u003e';
            this.secondContent = PrivateContent.toString();

            // this.getPoemList('file:///Users/tmz1/WebstormProjects/oinvip_web_app/src/assets/private.html');
        },
        watch: {
            value: function () {
                this.showModel = this.value;
            },
        },
        methods: {

            /** */
            getPoemList: function(file) {
                // file = "./assets/private.html";

                // function responseListener () {
                //     console.log(`this.responseText : ${this.responseText}`);
                // }
                let oReq = new XMLHttpRequest();
                // oReq.addEventListener("load", responseListener);
                oReq.open("GET", file, false);
                oReq.overrideMimeType('text/html;charset=utf-8')
                oReq.onreadystatechange = function () {
                    if (this.readyState === 4) {
                        if (this.status === 200 || this.status === 0) {
                            console.log(`this.responseText : ${this.responseText}`);
                        }
                    }
                }
                oReq.send(null);
            },

            onClickPolicy: function () {
                this.showPolicy = true;
            },

            onClosePolicy: function () {
                this.showPolicy = false;
            },

            cancel: function () {
                if (!this.showPolicy) {
                    this.showModel = false;
                    //回傳 result，外部接收到 result事件後再做處理
                    // args1 : 是否確定？
                    // args2 : 事件類型
                    this.$emit('result', false, this.eventType);
                } else {
                    this.showPolicy = false;
                }

            },
            confirm: function () {

                if (!this.isAgreePolicy) {
                    return this.$public.showNotify('您尚未同意隱私權條款', false);
                } else {
                    this.showModel = false;
                    //回傳 result，外部接收到 result事件後再做處理
                    this.$emit('result', true, this.eventType);
                }
            },

            /** 點擊 確認隱私權 */
            onClickConfirmPolicy: function () {
                this.showPolicy = false;
            }
        }
    }
</script>

<style lang="less" scoped>

    /deep/.privacy{
        .el-checkbox__label {
            font-size: 16px;

            a, span {
                color: var(--color-brown) !important;
                text-decoration: underline;

                &:hover {
                    color: var(--gray-dark);
                }
            }
        }
    }

    .dialog-footer {
        margin-top: 25px;
        width: 100%;
        display: flex;
        justify-content: space-around;

        .confirm {
            background: #F0F0ED;
            border: 0px
        }

        button {
            width: 105px;
        }
    }

</style>

